<template>
  <v-container fluid class="team px-2 px-md-0" :class="{ mobile: $vuetify.breakpoint.xsOnly }">

    <v-row class="row team-info-content text-md-left text-center mx-0 ml-md-5" v-if="$vuetify.breakpoint.smAndUp">
      <div class="d-flex justify-between col col-12">
        <div class="flex">
          <h2 class="mb-2 pa-0">Team</h2>
        </div>
        <div v-if="user.urole == 'admin' && user.usurgery !== null">
          <div class="text-right w-md-50">
            <v-btn small color="appGreen" class="white--text" @click="openInviteModal">
              Invite new members
              <v-icon small class="ml-2">mdi-send</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
      <v-col cols="12" v-if="total>0">
        <v-row>
          <v-col cols="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Name
                    </th>
                   
                    <th class="text-left">
                      Email
                    </th>
                    <th class="text-left">
                      Position
                    </th>
                     <th class="text-left">
                      GDC #
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, index) in users" :key="index">
                    <td>{{ user.firstName }} {{ user.lastName }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ user.position.name }}</td>
                    <td>{{ user.gdcNumber }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pt-0">
            <div class="pagination px-4">
              <div class="pagination-container">
                <v-container class="max-width">
                  <v-pagination color="#23A0A0" v-model="page" :length="parseInt(total / totalVisible, 10) + 1"
                    next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left" :page="page"
                    :total-visible="totalVisible"></v-pagination>
                </v-container>
              </div>
              <div class="item-per-page d-flex align-center justify-space-between">
                <p>Items Per Page</p>
                <v-select v-model="totalVisible" :items="items" dense></v-select>
                <p>
                  {{ page }}/{{
                    totalVisible == 0
                      ? 1
                      : parseInt(total / totalVisible, 10) + 1
                  }}
                  Pages
                </p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="orders-content-mobile" v-if="$vuetify.breakpoint.xsOnly">
      <v-col cols="12">
        <v-expansion-panels>
          <v-list>
            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <div>
                  <v-text-field class="orders-search" placeholder="Search" solo flat dense small hide-details
                    append-icon="mdi-magnify"></v-text-field>
                </div>
                <div class="d-flex justify-space-between align-center order-number">
                  <hr class="flex-grow-1" />
                  <div>
                    <pre>    Users    </pre>
                  </div>
                  <hr class="flex-grow-1" />
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="w-100">
                <div class="d-flex justify-space-between font-bold">
                  <div>Name</div>
                  <div>Email</div>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-for="user in users" :key="user.id">
              <v-list-item-content class="w-100">
                <div class="d-flex justify-space-between">
                  <div>{{ user.firstName }}&nbsp;{{ user.lastName }}</div>
                  <div>{{ user.email }}</div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <invite-team-member-dialog @close="showInviteModal=false" :show-invite-modal="showInviteModal" />

  </v-container>
</template>

<script>
  import {
    mapState
  } from "vuex";
  import InviteTeamMemberDialog from "@/components/Account/Pages/Team/InviteTeamMemberDialog.vue";

  export default {
    name: "TeamComponent",
    components: {
      InviteTeamMemberDialog
    },
    data: () => ({
      showInviteModal: false,
      page: 1,
      totalVisible: 10,
      length: 10,
      items: [{
          text: "10",
          value: 10
        },
        {
          text: "15",
          value: 15
        },
        {
          text: "All",
          value: 0
        }
      ]
    }),
    computed: {
      ...mapState({
        user: state => state.auth.user,
        users: state => state.team.users,
        total: state => state.team.totalUsers
      })
    },
    mounted() {
      this.$store.dispatch("team/GET_USERS", {
        from: 0,
        to: 10
      });
    },
    watch: {
      page(val) {
        let pagination = {
          itemsPerPage: this.totalVisible,
          page: val
        };
        this.updatePagination(pagination);
      },
      totalVisible(val) {
        let pagination = {
          itemsPerPage: val,
          page: this.page
        };
        this.updatePagination(pagination);
      }
    },
    methods: {
      getNumbers(start, stop) {
        return new Array(stop - start).fill(start).map((n, i) => n + i);
      },
      getUsers(payload) {
        this.$store
          .dispatch("team/GET_USERS", payload)
          .then(() => {
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            this.$swal("error", error.message, "error");
          });
      },
      updatePagination(pagination) {
        let payload = {};
        (payload.from =
          pagination.page * pagination.itemsPerPage - pagination.itemsPerPage),
        (payload.to =
          pagination.itemsPerPage === -1 ?
          this.totalItems :
          pagination.itemsPerPage);
        this.getUsers(payload);
      },
      openInviteModal() {
        this.showInviteModal = true;
        this.$forceUpdate();
      }
    }
  };
</script>
<style scoped lang="scss" src="./Team.scss"></style>
<style lang="scss">
  .team {
    .v-input {

      .v-label,
      input {
        font-size: 14px;
      }
    }

    .pagination {
      .v-pagination__item {
        color: #aaa;
        outline: none;

        &--active {
          color: #000 !important;
          background-color: transparent !important;
        }
      }

      .v-pagination__navigation i {
        color: #000;
      }

      .v-pagination__navigation,
      .v-pagination__item {
        box-shadow: none;
      }
    }

    .orders-search {
      .v-input__slot {
        background: #f2f2f2 !important;
        border-radius: 5px;
      }
    }

    .v-expansion-panel-header__icon {
      display: none;
    }

    .v-expansion-panel-content__wrap {
      padding: 0;
      background: #f9f2d0;
      border-radius: 0 0 5px 5px;

      .details {
        padding: 12px 10px;
        font-size: 16px;
        font-family: Gotham-Medium;

        &:first-child {
          color: #23a0a0;
        }

        &:last-child {
          color: #656565;
        }
      }

      .total {
        background: #ff6b6b;
        padding: 12px 10px;
        border-radius: 0 0 5px 5px;
        font-size: 18px;
        font-family: Gotham-Medium;
        color: #fff;
      }
    }
  }

  .team {
    >.row {
      &.orders-content {
        >.col {
          >.row {
            >.col-12 {
              .v-input.v-select {
                .v-text-field__details {
                  display: none !important;
                }
              }
            }
          }
        }
      }
    }
  }
</style>